import React from 'react';
import RenderLandingPage from './RenderLandingPage';

function LandingContainer() {
  return (
    <div
      style={{
        paddingTop: '80px',
      }}
    >
      <RenderLandingPage />
    </div>
  );
}

export default LandingContainer;
